import { cn } from '@/lib/utils';

interface SectionHeadingProps {
  kicker: string;
  title: string;
  sub?: string;
  className?: string;
}

export function SectionHeading({ kicker, title, sub, className }: SectionHeadingProps) {
  return (
    <div className={cn('space-y-3', className)}>
      <p className="font-mono text-sm text-primary">{kicker}</p>
      <h2 className="font-display text-3xl font-bold tracking-tight sm:text-4xl lg:text-[2.75rem] lg:leading-tight">
        {title}
      </h2>
      {sub && <p className="max-w-xl leading-relaxed text-muted-foreground">{sub}</p>}
    </div>
  );
}
